<template>
  <div>
    <v-date-picker
      v-model="value"
      mode="date"
      is24hr
      color="green"
      :is-dark="$store.state.darkMode"
      class="v-date-picker"
      :columns="$screens({ default: 1, lg: 2 })" 
    >
      <template v-slot="{ inputValue, inputEvents }">
        <svg
          class="pointer-events-none calendaricon"
          fill="none"
          stroke-linecap="rec"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          ></path>
        </svg>
        <input
          class="
            flex-grow
            pl-4
            pr-0
            py-1
            border
            w-full
            form-control
            reportrange-text
          "
          :value="inputValue"
          v-on="inputEvents"
        />
      </template>
      <!-- <template v-slot="{ inputValue, inputEvents }">
      <svg
        class="pointer-events-none"
        fill="none"
        stroke-linecap="rec"
        stroke-linejoin="round"
        stroke-width="2"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        ></path>
      </svg>
      <input
        class="
          flex-grow
          pl-4
          pr-0
          py-1
          border
          w-full
          form-control
          reportrange-text
        "
        :value="inputValue"
        v-on="inputEvents"
      />
    </template> -->
    </v-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {};
  },
  watch: {
    value: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.$emit("input", newVal);
      },
    },
  },
};
</script>

<style>
.v-date-picker svg.calendaricon {
  position: absolute;
  width: 16px;
  top: 6px;
  left: 5px;
}
</style>